function accountantColumns() {
  return [
    {
      Header: "Accountant Name",
      accessor: "name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Entity Name",
      accessor: "entity_name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Amount",
      accessor: "amount",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      disableFilters: true,
      filterable: false,
      Cell: ({ value }) => {
        let formattedDate = "-";
        if (value) {
          const date = new Date(value);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          formattedDate = `${day}-${month}-${year}`;
        }
        return (
          <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
            {formattedDate}
          </span>
          );
        },
    },
  ];
}

export default accountantColumns;
